import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSelectionsModel } from '../models/section_selections_model';

export type UpdateSectionSelectionCommand = (sectionId: ISection['id'], isSelected: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'updateSectionSelectionsCommand',
    function updateSectionSelectionsCommand(
      defineCommandORM: IDefineCommand,
      ngSectionSelectionsModel: SectionSelectionsModel
    ) {
      'use strict';

      return defineCommandORM(
        'updateSectionSelectionsCommand',
        (deferred, sectionId: ISection['id'], isSelected: boolean) => {
          const selectedSectionIds = ngSectionSelectionsModel.read().sectionIds;

          if (isSelected) {
            selectedSectionIds.add(sectionId);
          } else {
            selectedSectionIds.delete(sectionId);
          }
          ngSectionSelectionsModel.write({ sectionIds: selectedSectionIds });

          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/commands/update_section_selection_command.ts